import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Title from "../../Text/Title/Title";
import { useNavigate } from "react-router-dom";
import { IMember } from "../../../interfaces/IMember";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import useApiRequests from "../../../hooks/useApiRequests";
import { useNotification } from "../../../hooks/useNotification";
import { SubTitle } from "../../Text/Subtitle/SubTitle.tsx";
import { IoIosCopy } from "react-icons/io";
import { copyToClipBoard } from "../../../Functions/Functions.tsx";
import BigText from "../../Text/BigText/BigText";

import "./register.css";

function MemberEdit() {
  const { id } = useParams();
  const { getMemberById, updateMember, getMemberCode, createMember } =
    useApiRequests();
  const { notify } = useNotification();
  const navigate = useNavigate();

  const [member, setMember] = useState<IMember | null>(null);
  const [memberType, setMemberType] = useState("-1");

  useEffect(() => {
    if (id === null || id === "") {
      navigate(-1);
    } else {
      if (id !== "new") {
        const fetchData = async () => {
          const data = await getMemberById(id);
          if (data.success) {
            if (data.data.initDate) {
              data.data.initDate = new Date(data.data.initDate);
            }

            setMember(data.data);
            setMemberType(data.data.type);
          }
        };
        fetchData();
      }
    }
  }, []);

  const HandleSaveMember = async () => {
    const memberClone = JSON.parse(JSON.stringify(member));
    memberClone.memberType = memberType.toString();
    const data =
      id == "new"
        ? await createMember(memberClone || undefined)
        : await updateMember(memberClone || undefined);

    if (data.success && data.data) {
      notify("Alterações feitas com sucesso!", { type: "success" }); 
      if(id == "new")
        setTimeout(() => {window.location.href = `/member/edit/${data.data.id}`}, 500);
      else
        setMember(data.data)       
    }
    else{
      let msg = data.msg ? data.msg : "Ocorreu um erro ao salvar o usuário"
      notify(msg, { type: "error" }); 
    }
  };

  const handleMemberTypeChange = async () => {
    if (memberType !== "-1") {
      const data = await getMemberCode(member?.id || "", memberType || "");
      if (data.success) {
        if (data.data !== null && data.data !== "") {
          if (data.data.initDate) {
            data.data.initDate = new Date(data.data.initDate);
          }
          setMember(data.data);
          setMemberType(data.data.type);
          notify("Código de Login gerado com sucesso!", { type: "alert" });
          setTimeout(() => {
            window.location.href = `/member/edit/${data.data.id}`;
          }, 1000);
        }
      }
    }
  };

  const handleCopyToClipboard = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();

    // var url = `https://localhost:44485/authenticate/${member?.loginCode}`;
    var url = `devtracker.vendaerp.com.br/authenticate/${member?.loginCode}`;
    copyToClipBoard(url);
    notify("Copiado para a área de transferência!", { type: "alert" });
  };

  return (
    <div className="page-container">
      <div className="d-flex flex-wrap justify-content-between">
        <div className="title-and-subtitle">
          <Title >{member != null ? member.fullName : "Novo"}</Title>
          <SubTitle>Membro do quadro</SubTitle>
        </div>
        <div className="d-flex gap-2">
        <Button
            color="secondary"
            style={{ 
              height: "44px" }}
            onClick={() => window.location.href = "/register"}
          >
            Voltar
          </Button>
        <Button
          color="primary"
          onClick={HandleSaveMember}
          style={{
            height: "44px",
          }}
        >
          Salvar
        </Button>
        </div>
      </div>
      <div className="mt-5">
        <Form>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label className="theme-text-color" for="member-name">Nome</Label>
                <Input
                  className="custom-input"
                  id="member-name"
                  name="name"
                  type="text"                  
                  value={member?.fullName}
                  onChange={(e) =>
                    setMember((prevMember) => ({
                      ...prevMember,
                      fullName: e.target.value,
                    }))
                  }
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label className="theme-text-color" for="member-email">Email</Label>
                <Input
                className="custom-input"
                  id="member-email"
                  name="email"
                  type="email"
                  disabled={id != "new"}
                  value={member?.email?.toString()} //Não precisa do ToString() coloquei só pra tirar uma linha vermelha chata que fica kk
                  onChange={(e) =>
                    setMember((prevMember) => ({
                      ...prevMember,
                      email: e.target.value,
                    }))
                  }
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label className="theme-text-color" for="member-init-date">Data de início</Label>
                <Input
                className="custom-input"
                  id="member-init-date"
                  name="date"
                  placeholder="date placeholder"
                  type="date"
                  value={member?.initDate?.toISOString().split("T")[0]}
                  onChange={(e) =>
                    setMember((prevMember) => ({
                      ...prevMember,
                      initDate: new Date(e.target.value),
                      id: prevMember?.id || "",
                    }))
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label className="theme-text-color" for="member-type">Tipo de Usuário</Label>
                <Input
                className="custom-input"
                  type="select"
                  name="member-type"
                  id="member-type"
                  value={memberType}
                  onChange={(e) => {
                    setMemberType(e.target.value);
                    setMember((prevStatus) => ({
                      ...prevStatus,
                      memberType: memberType,
                      type: parseInt(e.target.value),
                    }));
                  }}
                >
                  <option value="-1">Selecione</option>
                  <option value="0">Suporte</option>
                  <option value="1">Desenvolvedor</option>
                  <option value="2">Gerenciador</option>
                  {/* <option value="3">Testador</option> */}
                </Input>
              </FormGroup>
            </Col>
            {id != "new" && (
              <>
                <Col md={3} style={{ marginTop: "30px" }}>
                  <Button onClick={() => handleMemberTypeChange()}>
                    Gerar Código
                  </Button>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label className="theme-text-color" for="member-code">Código de usuário</Label>
                    <div className="d-flex gap-1">
                      <Input
                      className="custom-input"
                        id="member-code"
                        name="member-code"
                        type="text"
                        disabled
                        value={member?.loginCode}
                      />
                      <Button
                        color="info"
                        onClick={(e) => handleCopyToClipboard(e)}
                      >
                        <IoIosCopy color="#FFF" size={18} />
                      </Button>
                    </div>
                  </FormGroup>
                </Col>
              </>
            )}
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label className="theme-text-color" for="pr-percentage">Senioridade Usuário</Label>
                <Input
                className="custom-input"
                  type="select"
                  name="pr-percentage"
                  id="pr-percentage"
                  value={member?.developerLevel}
                  onChange={(e) => {
                    setMember((prevStatus) => ({
                      ...prevStatus,
                      developerLevel: e.target.value,
                    }));
                  }}
                >
                  <option value="-1">Selecione</option>                  
                  <option value="JR">Júnior</option>
                  <option value="PL">Pleno</option>
                  <option value="SR">Sênior</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <span className="divider"></span>
          <p className="gray-text-subtitle mt-3">Configurações de Usuário</p>
          <Row className="mt-3">
            {member?.type !== 2 ? (
              <Col md={3}>
                <FormGroup check>
                  <Label check className="theme-text-color">
                    <Input
                      type="checkbox"
                      checked={member?.canMoveTasksManually || false}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setMember((prevStatus) => ({
                          ...prevStatus,
                          canMoveTasksManually: isChecked,
                        }));
                      }}
                    />{" "}
                    Movimentação manual de tarefas
                  </Label>
                  <Label check className="theme-text-color">
                    <Input
                      type="checkbox"
                      checked={member?.canCreateTasks || false}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setMember((prevStatus) => ({
                          ...prevStatus,
                          canCreateTasks: isChecked,
                        }));
                      }}
                    />{" "}
                    Criação de tarefas{" "}
                  </Label>
                </FormGroup>
              </Col>
            ) : (
              <>
                <Col md={3}>
                  <FormGroup check>
                    <Label check className="theme-text-color">
                      <Input
                        type="checkbox"
                        checked={member?.isDevToo || false}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setMember((prevStatus) => ({
                            ...prevStatus,
                            isDevToo: isChecked,
                          }));
                        }}
                      />{" "}
                      Cargo Desenvolvedor{" "}
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup check>
                    <Label check className="theme-text-color">
                      <Input
                        type="checkbox"
                        checked={member?.isSupToo || false}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setMember((prevStatus) => ({
                            ...prevStatus,
                            isSupToo: isChecked,
                          }));
                        }}
                      />{" "}
                      Cargo Suporte{" "}
                    </Label>
                  </FormGroup>
                </Col>
              </>
            )}
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default MemberEdit;
